export default [
  { type: 'request', fn: require('@/common/interceptors/request/auth').default },
  { type: 'request', fn: require('common/interceptors/request/global-params').default },
  { type: 'request', fn: require('common/interceptors/request/independent-uuid').default },
  { type: 'response', fn: require('common/interceptors/response/auth').default },
  { type: 'response', fn: require('common/interceptors/response/catalog').default },
  { type: 'response', fn: require('common/interceptors/response/coursewares-filters-v5').default },
  { type: 'response', fn: require('@/packages/platform/view/breadcrumb/interceptor').default },
];
